module.exports = __webpack_public_path__ + "static/media/star75.86cef408.png";